import { render, staticRenderFns } from "./FeaturesList.vue?vue&type=template&id=311923c7&scoped=true"
import script from "./FeaturesList.vue?vue&type=script&lang=js"
export * from "./FeaturesList.vue?vue&type=script&lang=js"
import style0 from "./FeaturesList.vue?vue&type=style&index=0&id=311923c7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311923c7",
  null
  
)

export default component.exports